export default __webpack_public_path__ + "static/media/piper-goat.dcf0b658.jpg";